import { MimaText, MimaButton, AppPage, MimaTable } from '../../components';
import {
	AddCustomerContainer,
	EditCustomerContainer,
	ViewCustomerContainer,
	DeleteCustomerContainer,
} from '../../containers';
import MimaOptionMenu from '../../components/OptionMenu/';
import styles from '../../assets/styles/Customer/Customer.module.scss';
import { AnimatePresence } from 'framer-motion';
import React, { useMemo, useState } from 'react';
import Survey from '../../components/Survey/Survey';
import { userStore } from '../../stores';
import constant from '../../utils/constant';
import { downloadXlsx2 } from '../../utils/download';

const Customer = ({
	loading,
	addCustomerModal,
	goToAddCustomer,
	closeModal,
	editCustomerModal,
	goToEditCustomer,
	viewCustomerModal,
	deleteCustomerModal,
	goBack,
	refresh,
	handleOptionSelect,
	isLoading,
	data,
	isFetching,
	limit,
	onLimitChange,
	currentPage,
	setCurrentPage,
	setSearchQuery,
	customerList,
}) => {
	const [showSurvey, setShowSurvey] = useState(false);

	const tableData = useMemo(() => {
		if (data?.status === constant.Success) {
			return data?.data?.customers || [];
		}
		return [];
	}, [data]);

	const tableColumns = [
		{
			Header: 'Name',
			accessor: 'fullname',
		},
		{
			Header: 'Phone Number',
			accessor: 'mobile',
		},
		{
			Header: 'Email',
			accessor: 'email',
		},
		{
			Header: 'Entity',
			accessor: 'gender',
		},
		{
			Header: 'Actions',
			Cell: ({ cell }) => {
				const status = cell.row.original.status;
				const customerId = cell.row.original._id;
				const customerDetail = cell.row.original;
				return (
					status !== constant.TRANSACTION_STATUS.VOID && (
						<MimaOptionMenu
							options={[
								{
									value: 'edit customer',
									label: 'Edit customer',
								},
								{
									value: 'delete customer',
									label: 'Delete customer',
								},
								{
									value: 'view more',
									label: 'View more',
								},
							]}
							onOptionSelected={option => {
								handleOptionSelect(customerId, customerDetail, option);
							}}
						/>
					)
				);
			},
		},
	];

	const printCustomerData = customerList.map(customer => ({
		Name: customer.fullname,
		'Phone Number': customer?.mobile,
		Email: customer?.email,
	}));

	return (
		<AppPage pageTitle="Customers" refresh={refresh}>
			<div className={styles.upper}>
				<div className={styles.customer__num}>
					<MimaText variant="smallBold">
						{data?.data?.totalCounts} Customers
					</MimaText>
					<MimaText variant="xsmall"> Updated 1 min ago </MimaText>
				</div>
			</div>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'end',
				}}>
				<MimaButton
					title="Download Customer Report"
					onClick={() => {
						downloadXlsx2(printCustomerData, `Customer Report`);
					}}
				/>
				<div className={styles.upper__btns}>
					<MimaButton
						title="Add Customer"
						variant="small"
						onClick={goToAddCustomer}
						mb={1}
					/>
				</div>
			</div>

			<MimaTable
				tableData={tableData}
				tableColumns={tableColumns}
				searchPlaceholder="Search Customer"
				searchVariant="wide"
				totalItems={data?.data?.totalCounts}
				onLimitChange={onLimitChange}
				isLoading={isLoading}
				isFetching={isFetching}
				limit={limit}
				currentPage={currentPage}
				setCurrentPage={setCurrentPage}
				setSearchQuery={setSearchQuery}
			/>

			{(addCustomerModal ||
				editCustomerModal ||
				viewCustomerModal ||
				deleteCustomerModal ||
				showSurvey) && (
				<div className="modal">
					<AnimatePresence>
						{addCustomerModal && (
							<AddCustomerContainer
								closeModal={closeModal}
								goBack={goBack}
								setShowSurvey={setShowSurvey}
							/>
						)}
						{showSurvey && (
							<Survey
								title=""
								reviewId={userStore.reviewId}
								closeModal={() => {
									setShowSurvey(false);
								}}
							/>
						)}
						{editCustomerModal && (
							<EditCustomerContainer
								closeModal={closeModal}
								goBack={goBack}
								setShowSurvey={setShowSurvey}
							/>
						)}
						{viewCustomerModal && (
							<ViewCustomerContainer
								closeModal={closeModal}
								goToEditCustomer={goToEditCustomer}
								goBack={goBack}
							/>
						)}
						{deleteCustomerModal && (
							<DeleteCustomerContainer
								closeModal={closeModal}
								goBack={goBack}
							/>
						)}
					</AnimatePresence>
				</div>
			)}
		</AppPage>
	);
};

export default Customer;
